import classNames from "classnames"
import { useController } from "react-hook-form"
import { useEffect, useRef } from "react"
import { TextMessage } from "@mobi/ds"

import "./TextArea.scss"

const MESSAGES = {
  required: "Campo obrigatório",
}

interface ITextArea {
  /** Concatena classes a classe padrão ds-button. */
  className?: string
  /** Controle de campo pelo useForms() do react-hooks-form */
  control: any
  /** Texto de label acima do campo */
  label?: string
  /** Maximo de caracteres permitido no campo */
  maxLength?: number
  /** Número de caracteres restantes para atigir o limite */
  realTimeLength?: number
  /** Name e ID do campo */
  name?: string
  /** Boolean de se o campo é required */
  required?: boolean
  /** Boolean de se o campo é disabled */
  disabled?: boolean
}

const TextArea = ({
  /** teste */
  className,
  control,
  label,
  maxLength,
  realTimeLength,
  name = "textArea",
  required = false,
  disabled,
  ...props
}: ITextArea) => {
  const {
    field,
    fieldState: { invalid, error, isTouched },
  } = useController({ name, control, rules: { required: required } })

  const isInvalid = isTouched && invalid
  const textAreaRef = useRef(null)

  const textAreaClass = classNames("ds-text-area", className, {
    "ds-text-area--invalid": isInvalid,
    "ds-text-area--disabled": disabled,
  })

  useEffect(() => {
    const textAreaDOM = textAreaRef.current
    textAreaDOM.setAttribute(
      "style",
      "height:" + textAreaDOM.scrollHeight + "px;overflow-y:hidden;"
    )
  }, [textAreaRef])

  const handleTextAreaHeight = (value) => {
    const textAreaDOM = textAreaRef.current
    if (textAreaDOM !== null) {
      textAreaDOM.style.height = "auto"
      textAreaDOM.style.height = `${textAreaDOM.scrollHeight}px`
    }

    return value
  }

  return (
    <div className={textAreaClass}>
      <label className="ds-text-area__label" htmlFor={name}>
        {label}
      </label>
      <div className="ds-text-area__field">
        <textarea
          {...props}
          {...field}
          id={name}
          maxLength={maxLength}
          rows={1}
          ref={textAreaRef}
          value={handleTextAreaHeight(field.value)}
        ></textarea>
      </div>
      <TextMessage message={MESSAGES[error?.type]} show={isInvalid} />
      {!isInvalid && maxLength && (
        <p className="ds-text-area__message ds-text-area__message--size">
          {
            realTimeLength !== undefined
            ? `${realTimeLength} ${realTimeLength > 1 ? "caracteres" : "caractere" }`
            : `${maxLength} caracteres`
          }        
          
        </p>
      )}
    </div>
  )
}

export default TextArea
